<template>
  <div class="login">
    <div class="login__authentication-page authentication-page" v-if="locale.login">
    <div class="authentication-page__logo-container">
      <img src="../assets/logo.svg" alt="mobilistics" class="logo">
    </div>
      <template v-if="!loadingState">
      <form action="" class="authentication-page__authentication-form login__authentication-form" @submit.prevent="submit">
        <div class="field-container">
          <errorMessages v-for="error in errors.all()" v-bind:key="error.id" v-bind:error="error"/>
          <label for="email">{{locale.login.customerid}}</label>
          <input type="text" :placeholder="locale.login.placeholder" v-model="form.cid" id="email" name="cid" required>

          <label for="password">{{locale.login.password}}</label>
          <input type="password" :placeholder="locale.login.password" id="password" v-model="form.password" name="password" required>

          <span class="login__forgot-passwd"><a href="#">{{locale.login.forgot_pass}}</a></span>
          <button type="submit" class="button button--login">{{locale.login.buttonText}}</button>
        </div>
          <div class="button-container">
          <router-link to="/register">
            <button type="button" class="button button--with-border button--login">{{locale.login.register}}</button>
          </router-link>
        </div>
      </form>
      </template>
      <template v-if="loadingState">
        <div class="spinner">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import errorMessages from '../utils/errorMessages.vue'
import { mapState } from 'vuex'

export default {
  name: 'Login',
  components: { errorMessages },
  computed: {
    ...mapState(['locale']),
    ...mapState({
      loadingState: state => state.loadingState
    })
  },
  data: function () {
    return {
      form: {
        cid: '',
        password: ''
      }
    }
  },
  methods: {
    submit () {
      this.errors.clear()
      this.$store.commit('setLoadingState', true, {root: true})
      this.$store.dispatch('getAuthUser', this.form).then((response) => {
        window.sessionStorage.setItem('jwt', response.data.data.jwt)
        window.sessionStorage.setItem('expires', response.data.data.expires)
        this.buttonText = 'Success'
        this.$store.dispatch('computes/getComputes')
        this.$store.dispatch('flavors/getFlavors')
        this.$store.dispatch('keypairs/getKeypairs')
        this.$store.dispatch('images/getImages')
        this.$store.dispatch('user/getUser')
        this.$store.dispatch('floating/getFloating')
        this.$store.commit('setLoadingState', false, {root: true})
        this.$router.push({name: 'Compute'})
      }).catch(() => {
        this.errors.add({field: 'user', msg: this.locale.login.errorText})
        this.$store.commit('setLoadingState', false, {root: true})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue